import { render, staticRenderFns } from "./registerSuccess.vue?vue&type=template&id=c252dfc6&scoped=true"
import script from "./registerSuccess.vue?vue&type=script&lang=ts"
export * from "./registerSuccess.vue?vue&type=script&lang=ts"
import style0 from "./registerSuccess.vue?vue&type=style&index=0&id=c252dfc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c252dfc6",
  null
  
)

export default component.exports